/* ==========================================================================
  main.js
========================================================================== */

// init macy.js
var grid_masonry = document.querySelectorAll('.grid-masonry');
var macy_pointers = [];
for (var i = 0; i < grid_masonry.length; i++) {
  var grid = grid_masonry[i];
  if (grid) {

    var breakAt = {
      620: {
        columns: 2
      },
      720: {
        margin: {
          x: 32,
          y: 32
        }
      },
      1680: {
        margin: {
          x: 32,
          y: 32
        }
      }
    };

    if (grid.classList.contains('grid-masonry--columns-3')) {
      breakAt = {
        620: {
          columns: 2
        },
        720: {
          columns: 2,
          margin: {
            x: 32,
            y: 32
          }
        },
        960: {
          columns: 3,
        },
        1680: {
          margin: {
            x: 32,
            y: 32
          }
        }
      };
    }

    var macy = Macy({
      container: grid,
      margin: {
        x: 32,
        y: 32
      },
      mobileFirst: true,
      columns: 1,
      breakAt: breakAt
    });
    macy_pointers.push(macy);

    macy.reInit();
  }

}

document.addEventListener('ajax-wp-query-ready', function(e) {
  for (var i = 0; i < macy_pointers.length; i++) {
    macy_pointers[i].reInit();
  }
});

window.addEventListener('resize', function(e) {
  for (var i = 0; i < macy_pointers.length; i++) {
    setTimeout(function(macy_pointer) {
      macy_pointer.reInit();
    }, 1000, macy_pointers[i]);
  }
});

/**
 * Init Responsive videos
 */
fitvids();

/**
 * Init AOS
 */

var aos = document.querySelectorAll('.media-text__media, .gallery__img, .key-figures__figure, .banner');

aos.forEach(function(el){

  if (el.classList.contains('gallery__img')) {
    el.setAttribute('data-aos', 'fade-in');
    el.setAttribute('data-aos-delay', [125, 250, 375, 500][Math.floor(Math.random() * 4)]);
  }

  else if (el.classList.contains('key-figures__figure')) {
    el.innerHTML = el.textContent.replace(/(?![^<]*>)[^<]/g, c => (c !== ' ') ? '<span data-aos="figure-up">' + c + '</span>' : c);
    el.querySelectorAll('span').forEach(function(el, i){
      el.setAttribute('data-aos-delay', i * 50);
    });
  }

  else {
    el.setAttribute('data-aos', 'fade-up');
  }

});

AOS.init({
  duration: 500
});

/**
 * Add class for styling on session start
 */
document.body.classList.remove('session-start');
if (window.sessionStorage.getItem('do_once_per_session') === null) {
  document.body.classList.add('session-start');
  window.sessionStorage.setItem('do_once_per_session', 1);
}
// remove session-start after 1,5 s
setTimeout(function() {
  document.body.classList.remove('session-start');
}, 1500);

/**
 * Init polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  objectFitPolyfill();
}

/**
 * Init lightbox
 */
if (document.querySelectorAll('.lightbox').length) {
  try {
    new Tobii({
      // variables from script localization in register-assets.php
      navLabel: [theme_strings.prev, theme_strings.next],
      closeLabel: theme_strings.close,
      loadingIndicatorLabel: theme_strings.loading,
      captionsSelector: 'self',
      captionAttribute: 'data-caption',
      zoom: false,
    });
  } catch (e) {
    console.log(e);
  }
}

/**
 * Sticky header
 */
var header = document.getElementById('masthead');

if (header) {
  var headroom_args = [];
  if (header.classList.contains('has-sub-header')) {
    headroom_args = {
      offset: 0,
      tolerance: 0,
      classes: {
        initial: "has-sub-header--animated",
        pinned: "has-sub-header--pinned",
        unpinned: "has-sub-header--unpinned"
      }
    };
  } else {
    headroom_args = {
      offset: 0,
      tolerance: 0,
      classes: {
        initial: "animated",
        pinned: "slideDown",
        unpinned: "slideUp"
      }
    };
  }

  var headroom = new Headroom(header, headroom_args);
  headroom.init();
}


/**
 * Gravity Forms
 */

document.querySelectorAll('.gfield').forEach(function(el){

  // add field type name to .gfield--type-x
  var container = el.querySelector('.ginput_container');
  if (container) {
    var container_classes = container.className.split(' ');
    for (var i = 0; i < container_classes.length; i++) {
      if (container_classes[i].indexOf('ginput_container_') > -1) {
        el.classList.add('gfield--type-' + container_classes[i].replace('ginput_container_', ''));
      }
    }
  }

  var input = el.querySelectorAll('input, textarea, select')[0];

  // wrapper sizing selector
  if (input) {
    if (input.classList.contains('small')) {
      el.classList.add('gfield--small');
    }

    if (input.classList.contains('medium')) {
      el.classList.add('gfield--medium');
    }
  }

  // wrapper filled input selector
  if (input && input.value) {
    el.classList.add('gfield--filled');
  }

  input.addEventListener('blur', function(e){
    if (e.target.value) {
      el.classList.add('gfield--filled');
    } else {
      el.classList.remove('gfield--filled');
    }
  });

});

/**
 * Add "has-viewport-effect" indicator class to blocks before they are seen.
 * Add "is-in-viewport" indicator class to blocks when they are in viewport.
 */
 const setInViewportIndicators = () => {

  // define matched elements
  const getMatchingElements = () => document.querySelectorAll([
    '.hero',
    '.wysiwyg > *',
    '.inner-blocks > *',
    '.wp-block-acf-button > *',
    '.wp-block-columns > *',
    '.wp-block-column > *',
    '.wp-block-gallery li',
    '.js-teaser-container > *',
    '.js-site-footer',
    '.js-add-viewport-effect',
    '.js-add-children-viewport-effect > *'
  ]);

  // flag to limit unnecessary updates
  let viewportElementsNeedToBeChecked = false;

  // disable animations for bots
  var botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|semrush|Cookiebot)";
  var re = new RegExp(botPattern, 'i');
  if (re.test(navigator.userAgent)) {
    return;
  }

  // disable animations for user preference
  const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (!mediaQuery || mediaQuery.matches) {
    return;
  }

  // check if given element is visible or partly visible on screen
  const isBlockVisible = (block) => {

    // intersectionobserver should be used when IE11 can be dropped
    const bounding = block.getBoundingClientRect();
    if (bounding.top >= -block.offsetHeight && bounding.left >= -block.offsetWidth && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) + block.offsetWidth && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) + block.offsetHeight) {
      return true;
    }

    return false;

  };

  // add initial state for matched elements
  const blocks = getMatchingElements();
  for (let i = 0; i < blocks.length; i++) {
    if (!isBlockVisible(blocks[i])) {
      blocks[i].classList.add('has-viewport-effect');
    } else {
      blocks[i].classList.add('is-in-viewport');
    }
  }

  const updateViewportStatus = () => {

    /**
     * Get animatable elements
     *
     * Preformance could be optimized by saving element in variable but that would also
     * require a mutationobserver or some custom event to indiate when the list should
     * be updted in case of ajax elements.
     */
    const blocks = getMatchingElements();

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      if (isBlockVisible(block)) {
        block.classList.add('is-in-viewport');
      }
    }

  };

  // update: manually trigger update first time to avoid latency
  updateViewportStatus();

  // update: hacky just in case updates
  setTimeout(() => { viewportElementsNeedToBeChecked = true; }, 1000);
  setTimeout(() => { viewportElementsNeedToBeChecked = true; }, 2500);

  // updaet: after render is complete
  window.addEventListener('DOMContentLoaded', (event) => {
    viewportElementsNeedToBeChecked = true;
  });
  window.addEventListener('load', (event) => {
    viewportElementsNeedToBeChecked = true;
  });

  // update: after scroll
  window.addEventListener('scroll', (e) => {
    viewportElementsNeedToBeChecked = true;
  }, false);

  // update: after resize
  window.addEventListener('resize', (event) => {
    viewportElementsNeedToBeChecked = true;
  });

  // limit updates for performance and battery drain
  setInterval(() => {
    if (viewportElementsNeedToBeChecked) {
      updateViewportStatus();
      viewportElementsNeedToBeChecked = false;
    }
  }, 100);

};
setInViewportIndicators();
